import { useContext, createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppConfig from "./appConfig";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem(AppConfig.session_object_storage_label) || "{}"));
  const [token, setToken] = useState(localStorage.getItem(AppConfig.session_storage_label) || "");
  const navigate = useNavigate();

  const setUserObject = (obj) => {
    localStorage.setItem(AppConfig.session_object_storage_label, JSON.stringify(obj));
    setUser(obj);
  }

  const loginAction = async (data) => {
    try {
      const response = await fetch("/practitioners/authenticate.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const res = await response.json();
      if (res.data) {
        setUser(res.data.user);
        setToken(res.token);
        localStorage.setItem("site", res.token);
        navigate("/dashboard");
        return;
      }
      throw new Error(res.message);
    } catch (err) {
      console.error(err);
    }
  };

  const logOut = () => {
    setUser(null);
    setToken("");
    localStorage.removeItem(AppConfig.auth_token);
    localStorage.removeItem(AppConfig.session_object_storage_label);
    localStorage.removeItem(AppConfig.session_storage_label);
    navigate("/login");
  };

  return (
    <AuthContext.Provider value={{ token, user, setToken, setUserObject, loginAction, logOut }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};
